// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('customerorder', {
        url: '/customerorder',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/customerorder/customerorder.tpl.html',
        controller: 'MainCustomerOrderController as vm'
    });
}

// @ngInject
function MainCustomerOrderController() {
    var vm = this;
}

angular
    .module('main.customerorder', ['customerorders.api','customerorder.customerordersearch'])
    .config(stateConfig)
    .controller('MainCustomerOrderController', MainCustomerOrderController);
